export default __webpack_public_path__ + "static/media/526-Semi-automatic-Gas-switchover.d367b489.jpg";